export const getMatchedCoupons = (coupons, crmCoupons = []) => {
  const crmCouponIds = crmCoupons?.map(crmCoupon => crmCoupon.couponId) ?? []

  const crmCouponMap = crmCoupons
    ? Object.fromEntries(
        crmCoupons?.map(crmCoupon => [crmCoupon.couponId, crmCoupon])
      )
    : {}

  const matchedItems = coupons
    .filter(coupon => crmCouponIds.includes(coupon.couponId))
    .map(coupon => {
      const crmData = crmCouponMap[coupon.couponId]
      return {
        ...coupon,
        isActivated: crmData?.isActivated,
        redeemableOnce: crmData?.redeemableOnce
      }
    })

  return matchedItems
}
